import { mergeObjectTypes } from '../cacheHelpers';

const Tracking = {
  merge: mergeObjectTypes
};

export default Tracking;
